import FormController from "./form_controller";

export default class extends FormController {
  static targets = ["trixContent", "draftStatusDisplay"];
  static values = {
    draftUrl: String,
  };

  connect() {
    super.connect();

    if (this.trixContentTarget) {
      this.trixContentTarget.addEventListener("trix-change", this.handleTrixContentChange);
    }

    this.handleTurboBeforeVisit = this._turboBeforeVisit.bind(this);

    document.addEventListener("turbo:before-visit", this.handleTurboBeforeVisit);
    document.addEventListener("dialog:modal:open", this.handleModalOpen);

    this.isDirty = false;
    this.destination = null;

    // Code from the old autosaving version of this. Kept in case we want it later.
    // Regularly check and see if it's been long enough to autosave a draft.
    // this.tick = setInterval(() => {
    //   this.checkTimeToSave();
    // }, 333);
  }

  disconnect() {
    super.disconnect();

    if (this.trixContentTarget) {
      this.trixContentTarget.removeEventListener("trix-change", this.handleTrixContentChange);
    }

    document.removeEventListener("turbo:before-visit", this.handleTurboBeforeVisit);
    document.removeEventListener("dialog:modal:open", this.handleModalOpen);

    clearInterval(this.tick);
  }

  onSubmit = (event) => {
    if (this.validateForm()) {
      this.isDirty = false;
      return;
    }

    event.preventDefault();
    this.firstInvalidField.focus();
  };

  _turboBeforeVisit(event) {
    if (
      this.isDirty &&
      confirm("You have unsaved changes to your message. Would you like to save a draft?")
    ) {
      event.preventDefault();
      this.destination = event.detail.url;
      this.draftSubmit();
    }
  }

  handleTrixContentChange = (_event) => {
    // This is code from the old autosaving version of this function. I'm keeping it in case we want it later.
    // const timeOffset = 1.5 * 1000; // We want to save after 1.5 seconds of inactivity
    // this.timeToSaveDraft = new Date(new Date().getTime() + timeOffset);

    this.draftStatusDisplayTarget.classList.remove("saved");
    this.draftStatusDisplayTarget.classList.add("saving");
    this.isDirty = true;
  };

  handleModalOpen = (_event) => {
    if (
      this.isDirty &&
      confirm("You have unsaved changes to your message. Would you like to save a draft?")
    ) {
      this.draftSubmit();
    }
  };

  checkTimeToSave = () => {
    if (this.timeToSaveDraft ? new Date() > this.timeToSaveDraft : false) {
      this.timeToSaveDraft = null;
      this.draftStatusDisplayTarget.classList.remove("saved");
      this.draftStatusDisplayTarget.classList.add("saving");
      this.draftSubmit();
    }
  };

  draftSubmit = () => {
    const formData = new FormData(this.element);
    const data = {
      authenticity_token: formData.get("authenticity_token"),
      draft: { content: formData.get("message[content]") },
    };

    fetch(this.draftUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.status === 200) {
        this.draftStatusDisplayTarget.classList.remove("saving");
        this.draftStatusDisplayTarget.classList.add("saved");
        this.isDirty = false;

        if (this.destination) window.location.href = this.destination;

        this.destination = null;
      }
    });
  };
}
